import React, { Component } from "react"

class SelectButton extends Component{
    constructor(props) {
        super(props);
        this.state = {
            value : this.props.value
        };

        this.onClick = this.onClick.bind(this);
    }
    onClick(e){
        let {value} = e.currentTarget.attributes.getNamedItem("value");
        if (value === "true" || value === "false"){
            value = (value === "true");
        }
        
        if (typeof this.props.onChange === "function"){
            this.props.onChange(value, this.props.name);
        }
    }
    render() {
        return (
            <div className="btn-group" role="group">
                {
                    this.props.options.map(function(option, index){
                        return <button key={index} value={option.value} onClick={this.onClick} type="button" className={"btn pd-x-25" + (this.props.value === option.value ? " btn-indigo active" : " btn-outline-indigo")}>{option.label}</button>
                    }, this)
                }
                <input type="hidden" name={this.props.name} value={this.props.value}/>
            </div>
        );
    }
};

export default SelectButton;

